(function () {
  'use strict';

  function handleEditClick(btn) {
    var row = btn.closest('.cart-item');
    var panel = row.querySelector('.mtsc-edit-panel');
    if (panel.classList.contains('mtsc-edit-open')) {
      closePanel(panel);
      return;
    }
    openPanel(panel, row.dataset.productHandle, parseInt(row.dataset.variantId), parseInt(row.dataset.lineIndex));
  }

  function openPanel(panel, handle, currentVariantId, lineIndex) {
    panel.innerHTML = '<p class="mtsc-edit-loading">Loading options…</p>';
    panel.classList.add('mtsc-edit-open');

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) { renderPanel(panel, product, currentVariantId, lineIndex); })
      .catch(function () {
        panel.innerHTML = '<p class="mtsc-edit-loading">Could not load options.</p>';
      });
  }

  function renderPanel(panel, product, currentVariantId, lineIndex) {
    var lowerOptions = product.options.map(function (o) {
      return (typeof o === 'string' ? o : o.name).toLowerCase();
    });
    var sizeIdx = lowerOptions.indexOf('size');
    var colorIdx = lowerOptions.indexOf('color');
    if (colorIdx === -1) colorIdx = lowerOptions.indexOf('colour');

    var variantMap = {};
    product.variants.forEach(function (v) {
      variantMap[v.option1 + '|' + v.option2 + '|' + v.option3] = v;
    });

    var currentVariant = product.variants.find(function (v) { return v.id === currentVariantId; }) || product.variants[0];
    var currentOpts = [currentVariant.option1, currentVariant.option2, currentVariant.option3];

    function getOpt(idx) { return idx >= 0 ? currentOpts[idx] : null; }
    var currentSize = getOpt(sizeIdx);
    var currentColor = getOpt(colorIdx);

    function getVariant(size, color) {
      var opts = [currentOpts[0], currentOpts[1], currentOpts[2]];
      if (sizeIdx >= 0) opts[sizeIdx] = size || currentSize;
      if (colorIdx >= 0) opts[colorIdx] = color || currentColor;
      return variantMap[opts[0] + '|' + opts[1] + '|' + opts[2]];
    }

    var sizes = [];
    var colors = [];
    product.variants.forEach(function (v) {
      var s = sizeIdx >= 0 ? v['option' + (sizeIdx + 1)] : null;
      var c = colorIdx >= 0 ? v['option' + (colorIdx + 1)] : null;
      if (s && sizes.indexOf(s) === -1) sizes.push(s);
      if (c && colors.indexOf(c) === -1) colors.push(c);
    });

    var html = '<div class="mtsc-edit-inner" data-line-index="' + lineIndex + '">';

    if (sizes.length > 0) {
      html += '<div class="mtsc-edit-option-group">';
      html += '<span class="mtsc-edit-option-label">Size</span>';
      html += '<div class="mtsc-edit-size-pills">';
      sizes.forEach(function (size) {
        var v = getVariant(size, currentColor);
        var available = v && v.available;
        var selected = size === currentSize;
        html += '<button type="button" class="mtsc-edit-pill' +
          (selected ? ' mtsc-edit-selected' : '') +
          (available ? '' : ' mtsc-edit-unavailable') + '"' +
          ' data-size="' + escAttr(size) + '"' +
          (available ? '' : ' disabled') + '>' +
          escHtml(size) + '</button>';
      });
      html += '</div></div>';
    }

    if (colors.length > 0) {
      html += '<div class="mtsc-edit-option-group">';
      html += '<span class="mtsc-edit-option-label">Color</span>';
      html += '<div class="mtsc-edit-color-pills">';
      colors.forEach(function (color) {
        var v = getVariant(currentSize, color);
        var available = v && v.available;
        var selected = color === currentColor;
        html += '<button type="button" class="mtsc-edit-pill' +
          (selected ? ' mtsc-edit-selected' : '') +
          (available ? '' : ' mtsc-edit-unavailable') + '"' +
          ' data-color="' + escAttr(color) + '"' +
          (available ? '' : ' disabled') + '>' +
          escHtml(color) + '</button>';
      });
      html += '</div></div>';
    }

    var resolvedVariant = getVariant(currentSize, currentColor);
    html += '<div class="mtsc-edit-actions">';
    html += '<button type="button" class="mtsc-edit-cancel">Cancel</button>';
    html += '<button type="button" class="mtsc-edit-update"' +
      ' data-old-variant-id="' + currentVariantId + '"' +
      ' data-variant-id="' + (resolvedVariant ? resolvedVariant.id : '') + '"' +
      (!resolvedVariant ? ' disabled' : '') + '>Update item</button>';
    html += '</div>';
    html += '</div>';

    panel.innerHTML = html;
    panel._mtscProduct = product;
    panel._mtscSizeIdx = sizeIdx;
    panel._mtscColorIdx = colorIdx;
    panel._mtscCurrentSize = currentSize;
    panel._mtscCurrentColor = currentColor;
    panel._mtscVariantMap = variantMap;
    panel._mtscCurrentOpts = currentOpts.slice();

    bindPanelEvents(panel);
  }

  function bindPanelEvents(panel) {
    panel.querySelectorAll('[data-size]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        panel._mtscCurrentSize = this.dataset.size;
        updateSelections(panel);
      });
    });

    panel.querySelectorAll('[data-color]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        panel._mtscCurrentColor = this.dataset.color;
        updateSelections(panel);
      });
    });

    panel.querySelector('.mtsc-edit-cancel').addEventListener('click', function () {
      closePanel(panel);
    });

    panel.querySelector('.mtsc-edit-update').addEventListener('click', function () {
      submitVariantChange(panel);
    });
  }

  function updateSelections(panel) {
    var product = panel._mtscProduct;
    var sizeIdx = panel._mtscSizeIdx;
    var colorIdx = panel._mtscColorIdx;
    var currentSize = panel._mtscCurrentSize;
    var currentColor = panel._mtscCurrentColor;
    var baseOpts = panel._mtscCurrentOpts.slice();

    function getVariant(size, color) {
      var opts = baseOpts.slice();
      if (sizeIdx >= 0) opts[sizeIdx] = size;
      if (colorIdx >= 0) opts[colorIdx] = color;
      return panel._mtscVariantMap[opts[0] + '|' + opts[1] + '|' + opts[2]];
    }

    panel.querySelectorAll('[data-size]').forEach(function (pill) {
      var size = pill.dataset.size;
      var v = getVariant(size, currentColor);
      pill.classList.toggle('mtsc-edit-selected', size === currentSize);
      pill.classList.toggle('mtsc-edit-unavailable', !(v && v.available));
      pill.disabled = !(v && v.available);
    });

    panel.querySelectorAll('[data-color]').forEach(function (pill) {
      var color = pill.dataset.color;
      var v = getVariant(currentSize, color);
      pill.classList.toggle('mtsc-edit-selected', color === currentColor);
      pill.classList.toggle('mtsc-edit-unavailable', !(v && v.available));
      pill.disabled = !(v && v.available);
    });

    var resolved = getVariant(currentSize, currentColor);
    var updateBtn = panel.querySelector('.mtsc-edit-update');
    if (resolved) {
      updateBtn.dataset.variantId = resolved.id;
      updateBtn.disabled = !resolved.available;
    } else {
      updateBtn.dataset.variantId = '';
      updateBtn.disabled = true;
    }
  }

  function submitVariantChange(panel) {
    var inner = panel.querySelector('.mtsc-edit-inner');
    var updateBtn = panel.querySelector('.mtsc-edit-update');
    var newVariantId = parseInt(updateBtn.dataset.variantId);
    var oldVariantId = parseInt(updateBtn.dataset.oldVariantId);

    if (!newVariantId) return;
    if (newVariantId === oldVariantId) { closePanel(panel); return; }

    var row = panel.closest('.cart-item');
    var qtyInput = row.querySelector('input[name="updates[]"]');
    var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    updateBtn.disabled = true;
    updateBtn.textContent = 'Updating…';

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(newVariantId), quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: String(oldVariantId),
          quantity: 0,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });
    })
    .then(function (r) {
      if (!r.ok) throw new Error('remove failed');
      return r.json();
    })
    .then(function (state) {
      rerenderDrawer(state.sections);
    })
    .catch(function (err) {
      console.error('mtsc variant swap failed:', err);
      updateBtn.disabled = false;
      updateBtn.textContent = 'Update item';
    });
  }

  function rerenderDrawer(sections) {
    if (!sections) return;

    var drawerEl = document.querySelector('#CartDrawer');
    if (drawerEl && sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var updated = doc.querySelector('#CartDrawer');
      if (updated) drawerEl.innerHTML = updated.innerHTML;
    }

    var bubbleEl = document.getElementById('cart-icon-bubble');
    if (bubbleEl && sections['cart-icon-bubble']) {
      var doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var updated2 = doc2.querySelector('.shopify-section');
      if (updated2) bubbleEl.innerHTML = updated2.innerHTML;
    }

    var overlay = document.querySelector('#CartDrawer-Overlay');
    var cartDrawer = document.querySelector('cart-drawer');
    if (overlay && cartDrawer) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));

  }

  function closePanel(panel) {
    panel.classList.remove('mtsc-edit-open');
    panel.innerHTML = '';
    delete panel._mtscProduct;
  }

  function escAttr(str) {
    return String(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function escHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Auto-expand edit panel for items added via quiz
  document.addEventListener('mtsc:quiz-added', function (e) {
    var variantId = e.detail && e.detail.variantId;
    if (!variantId) return;
    setTimeout(function () {
      var row = document.querySelector('.cart-item[data-variant-id="' + variantId + '"]');
      if (!row) return;
      var btn = row.querySelector('.mtsc-cart-edit-btn');
      if (btn) btn.click();
    }, 350);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mtsc-cart-edit-btn');
    if (!btn) return;
    handleEditClick(btn);
  });
})();
